
import { Component, Prop, Vue } from "vue-property-decorator";
import QuickAction from "@/components/V2/QuickActions/QuickAction.vue";
import IconBadge from "@/components/V2/IconBadge/iconBadge.vue";
import InfoButton from "@/components/V2/QuickActions/InfoButton.vue";
import { SMAdditionalInfo, SMUser } from "@/store";
import { COMPLIANT } from "@/constants/compliance";

const MESSAGES = {
  title: "Quick Actions",
  info: {
    is_not_sponsor: "Complete your Sponsor Licence application to unlock all features",
    blocked: "Get your Compliance Plan to unlock all Compliance features",
    not_setup: "Complete your account setup to unlock all features",
  },
};

@Component({
  components: {
    InfoButton,
    IconBadge,
    QuickAction,
  },
})
export default class QuickActions extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly items;

  MESSAGES = MESSAGES;

  get buttons() {
    return SMAdditionalInfo.filteredQuickActions;
  }

  get info() {
    if (!SMUser.isSponsor) return MESSAGES.info.is_not_sponsor;

    if (SMUser.isComplianceBlocked) return MESSAGES.info.blocked;

    if (!SMAdditionalInfo.isOnboardingCompleted) return MESSAGES.info.not_setup;

    return "";
  }

  get showInfo() {
    return this.info && !this.hasComplianceSubscription;
  }

  get homePageInfo() {
    return SMAdditionalInfo.currentHomePageActualInfo ?? null;
  }

  get hasComplianceSubscription() {
    if (!this.homePageInfo) return false;

    const { compliance } = this.homePageInfo;

    if (!compliance) return false;

    return compliance?.compliance_status === COMPLIANT && compliance?.compliance_package !== null;
  }

  tooltipPositions = [] as string[];

  calculateTooltipPositions() {
    const container = this.$el.querySelector(".quick-actions-items");
    const buttons = container?.children || [];
    const containerRight = container?.getBoundingClientRect().right || 0;

    this.tooltipPositions = Array.from(buttons).map((el) => {
      const rect = el.getBoundingClientRect();
      const distanceToRight = containerRight - rect.right;

      return distanceToRight < 128 ? "left" : "bottom";
    });
  }

  mounted() {
    this.$nextTick(() => {
      this.calculateTooltipPositions();

      const observer = new (window as any).ResizeObserver(() => {
        this.calculateTooltipPositions();
      });
      observer.observe(this.$el.querySelector(".quick-actions-items"));
    });
  }
}
